import clsx from 'clsx';
import Image from 'next/image';

import PremiumIcon from '../PremiumIcon';
import { SkeletalRefLoaderText } from '../SkeletalRefLoader';

import { UserCreditType } from '../../utils/server-side/credits';

import TopUpButton from './TopUpButton';

interface Props {
  className?: string;
  userCredit: UserCreditType;
  isLoading?: boolean;
  onRedirect?: (route: string) => void;
}

const CreditDisplay = ({
  className,
  userCredit,
  isLoading = false,
  onRedirect,
}: Props) => {
  const { credits = 0, paidCredits = 0 } = userCredit;

  return (
    <div className={clsx('flex h-full items-center', className)}>
      {(credits > 0 || isLoading) && (
        <div className="mr-2 flex items-center justify-center gap-[2px] text-base leading-none lg:text-sm">
          <Image
            alt="stars"
            height={14}
            src="/images/blue-stars.svg"
            width={14}
          />
          <b aria-label={`${credits || 0} Regular`}>
            {isLoading ? (
              <SkeletalRefLoaderText />
            ) : (
              <>
                {credits || 0} <span className="hidden lg:inline">Regular</span>
              </>
            )}
          </b>
        </div>
      )}
      <div className="group relative z-40 flex h-10 items-center justify-center border-l border-gray-200 py-1 pl-2">
        <div className="mr-2 flex items-center justify-center text-base leading-none lg:text-sm">
          <PremiumIcon className="h-5 fill-[#FFB743]" />
          <b>
            {isLoading ? (
              <SkeletalRefLoaderText />
            ) : (
              <>
                {paidCredits || 0}{' '}
                <span className="hidden lg:inline">Premium</span>
              </>
            )}
          </b>
        </div>
      </div>
      <TopUpButton onRedirect={onRedirect} />
    </div>
  );
};

export default CreditDisplay;
